var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 70,
    viewBox: "0 0 68 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40033 47.6596C6.79682 50.1506 8.61042 52.4013 10.8268 54.2914C14.5286 57.4482 18.8877 60.9053 23.0378 63.5677C25.1129 64.8989 27.1169 66.0191 28.9462 66.8038C30.7884 67.5941 32.3857 68.0142 33.6667 68.0142C35.0704 68.0142 36.7575 67.5849 38.6549 66.7903C40.5427 65.9996 42.5816 64.8718 44.6732 63.533C48.857 60.8551 53.1783 57.3809 56.8147 54.218C58.9709 52.3424 60.7282 50.1171 62.077 47.6596H64.3002C62.7906 50.692 60.7212 53.4408 58.0976 55.7228C54.4282 58.9145 50.0249 62.4587 45.7255 65.2105C43.5757 66.5865 41.4334 67.7762 39.4078 68.6246C37.3918 69.4689 35.4332 70 33.6667 70C32.0058 70 30.1271 69.4678 28.1778 68.6316C26.2157 67.7899 24.1126 66.6096 21.9838 65.2439C17.7261 62.5126 13.2901 58.991 9.5585 55.8089C6.8651 53.512 4.72974 50.7333 3.16633 47.6596H5.40033Z",
    fill: "url(#paint0_linear_1_3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0955 49.4369C28.9978 49.4369 29.6407 50.0922 29.6407 51.0632C29.6407 51.1109 29.6349 51.1825 29.629 51.2361H27.0928C27.1636 51.7901 27.6061 52.1594 28.2253 52.1594C28.591 52.1594 28.8976 52.0343 29.1276 51.7781L29.4403 52.1475C29.1572 52.4812 28.7265 52.6597 28.2075 52.6597C27.1991 52.6597 26.5267 51.9866 26.5267 51.0453C26.5267 50.1101 27.1932 49.437 28.0955 49.4369ZM28.0955 49.9196C27.5529 49.9196 27.1518 50.2888 27.0928 50.825H29.0981C29.0391 50.2948 28.644 49.9196 28.0955 49.9196Z",
    fill: "url(#paint1_linear_1_3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5757 49.4369C38.4781 49.4369 39.121 50.0922 39.121 51.0632C39.121 51.1109 39.1151 51.1825 39.1092 51.2361H36.5731C36.6439 51.7901 37.0863 52.1594 37.7056 52.1594C38.0712 52.1594 38.3779 52.0343 38.6079 51.7781L38.9206 52.1475C38.6375 52.4812 38.2068 52.6597 37.6878 52.6597C36.6793 52.6597 36.007 51.9866 36.007 51.0453C36.007 50.1101 36.6735 49.437 37.5757 49.4369ZM37.5757 49.9196C37.0332 49.9196 36.6321 50.2888 36.5731 50.825H38.5784C38.5194 50.2948 38.1242 49.9196 37.5757 49.9196Z",
    fill: "url(#paint2_linear_1_3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4174 49.4369C50.3198 49.4369 50.9627 50.0922 50.9627 51.0632C50.9627 51.1109 50.9568 51.1825 50.9509 51.2361H48.4148C48.4856 51.7901 48.928 52.1594 49.5473 52.1594C49.9129 52.1594 50.2196 52.0343 50.4496 51.7781L50.7623 52.1475C50.4792 52.4812 50.0485 52.6597 49.5295 52.6597C48.521 52.6597 47.8487 51.9866 47.8487 51.0453C47.8487 50.1101 48.5151 49.437 49.4174 49.4369ZM49.4174 49.9196C48.8749 49.9196 48.4738 50.2888 48.4148 50.825H50.4201C50.3611 50.2948 49.9659 49.9196 49.4174 49.9196Z",
    fill: "url(#paint3_linear_1_3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6978 52.6241H54.1552V52.1238C53.9016 52.4811 53.5006 52.6597 53.0407 52.6597C52.1265 52.6597 51.4599 52.0104 51.4599 51.0453C51.46 50.0802 52.1266 49.4369 53.0407 49.4369C53.483 49.4369 53.8722 49.6038 54.1316 49.9433V48.2038H54.6978V52.6241ZM53.0877 49.9373C52.4862 49.9373 52.0321 50.3722 52.032 51.0453C52.032 51.7185 52.4862 52.1594 53.0877 52.1594C53.6834 52.1594 54.1376 51.7185 54.1376 51.0453C54.1376 50.3722 53.6834 49.9373 53.0877 49.9373Z",
    fill: "url(#paint4_linear_1_3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6697 52.6241H16.0505L15.5962 51.5815H13.4023L12.9483 52.6241H12.3406L14.2103 48.4539H14.7942L16.6697 52.6241ZM13.6087 51.1049H15.3898L14.4993 49.0617L13.6087 51.1049Z",
    fill: "url(#paint5_linear_1_3)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.884 49.9908C18.8368 49.9849 18.7954 49.985 18.7542 49.985C18.1467 49.985 17.7693 50.3603 17.7693 51.0514V52.6241H17.2029V49.4667H17.7455V49.9969C17.946 49.6275 18.3355 49.4369 18.884 49.4369V49.9908Z",
    fill: "url(#paint6_linear_1_3)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2627 49.9908C21.2155 49.9849 21.1741 49.985 21.1329 49.985C20.5254 49.985 20.148 50.3603 20.148 51.0514V52.6241H19.5816V49.4667H20.1242V49.9969C20.3247 49.6275 20.7142 49.4369 21.2627 49.4369V49.9908Z",
    fill: "url(#paint7_linear_1_3)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5267 52.6241H21.9603V49.4667H22.5267V52.6241Z",
    fill: "url(#paint8_linear_1_3)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7223 51.9987L25.8192 49.4667H26.3738L25.0055 52.6241H24.4273L23.0592 49.4667H23.6488L24.7223 51.9987Z",
    fill: "url(#paint9_linear_1_3)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7036 48.4539C34.7769 48.454 35.4257 49.002 35.4257 49.9074C35.4257 50.5508 35.0954 51.0157 34.5174 51.2242L35.4965 52.6241H34.8536L33.963 51.3432C33.8805 51.3492 33.7921 51.3551 33.7036 51.3551H32.6832V52.6241H32.0933V48.4539H33.7036ZM32.6832 50.8487H33.6859C34.4408 50.8487 34.8359 50.5032 34.8359 49.9074C34.8358 49.3117 34.4407 48.9722 33.6859 48.9722H32.6832V50.8487Z",
    fill: "url(#paint10_linear_1_3)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0219 48.1679C41.2637 48.1679 41.4996 48.2276 41.6588 48.3526L41.4879 48.7875C41.37 48.6981 41.2165 48.6387 41.0514 48.6387C40.7153 48.6387 40.5443 48.8292 40.5443 49.1926V49.4667H41.4524V49.9373H40.5561V52.6241H39.9897V49.9373H39.4591V49.4667H39.9897V49.1868C39.9897 48.5732 40.3555 48.1679 41.0219 48.1679Z",
    fill: "url(#paint11_linear_1_3)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0272 52.6241H42.4611V49.4667H43.0272V52.6241Z",
    fill: "url(#paint12_linear_1_3)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.775 49.4369C46.5358 49.4369 47.0725 49.8777 47.0726 50.807V52.6241H46.5064V50.8727C46.5064 50.2532 46.1998 49.9492 45.6631 49.9491C45.0616 49.9491 44.6723 50.3127 44.6723 50.9978V52.6241H44.1059V49.4667H44.6485V49.9433C44.8785 49.6216 45.2796 49.4369 45.775 49.4369Z",
    fill: "url(#paint13_linear_1_3)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2435 48.1143C22.4617 48.1143 22.627 48.2752 22.627 48.4777C22.627 48.6922 22.4676 48.859 22.2435 48.859C22.0253 48.859 21.8602 48.6981 21.8602 48.4896C21.8603 48.2811 22.0253 48.1143 22.2435 48.1143Z",
    fill: "url(#paint14_linear_1_3)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.744 48.1143C42.9622 48.1143 43.1275 48.2752 43.1275 48.4777C43.1275 48.6922 42.9681 48.859 42.744 48.859C42.5258 48.859 42.3607 48.6981 42.3607 48.4896C42.3608 48.2811 42.5259 48.1144 42.744 48.1143Z",
    fill: "url(#paint15_linear_1_3)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1334 38.4274C36.3727 38.4274 37.4006 38.8549 38.0857 39.6589L37.0377 40.636C36.5239 40.0864 35.9294 39.8319 35.2141 39.8319C33.8438 39.832 32.9069 40.7582 32.9069 42.1118C32.9069 43.445 33.8439 44.3914 35.1939 44.3914C35.6372 44.3914 36.0504 44.3101 36.4634 44.0862V41.9998H37.9547V44.8901C37.1789 45.4803 36.1107 45.7959 35.1032 45.7959C32.8867 45.7959 31.2544 44.2591 31.2544 42.1118C31.2544 39.9644 32.8866 38.4274 35.1334 38.4274Z",
    fill: "url(#paint16_linear_1_3)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.242 45.6738H10.529L9.90432 44.1471H6.63L6.00532 45.6738H4.33264L4.98972 44.1844H3.56326L4.17762 42.9433H7.37226V42.8953H9.39051L8.2722 40.1679L7.3377 42.4468H5.75646L7.47617 38.5496H9.08838L12.242 45.6738Z",
    fill: "url(#paint17_linear_1_3)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0265 38.5496C17.9106 38.5496 19.0894 39.5368 19.0894 41.1346C19.0894 42.7223 17.9106 43.7095 16.0265 43.7095H14.6058V45.6738H12.9737V40.461H14.6058V42.3661H15.9358C16.9333 42.3661 17.4371 41.9081 17.4371 41.1346C17.4371 40.351 16.9332 39.893 15.9358 39.893H14.6058V39.9645H12.9737V38.5496H16.0265Z",
    fill: "url(#paint18_linear_1_3)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.111 42.8749V38.5496H26.723V45.6738H25.3832L21.8667 41.3485V45.6738H20.2548V38.5496H21.6049L25.111 42.8749Z",
    fill: "url(#paint19_linear_1_3)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.024 45.6738H28.3918V38.5496H30.024V45.6738Z",
    fill: "url(#paint20_linear_1_3)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4532 45.6738H44.7402L44.1155 44.1471H40.8412L40.2165 45.6738H38.5438L41.6874 38.5496H43.2996L46.4532 45.6738ZM41.3651 42.8953H43.6017L42.4834 40.1679L41.3651 42.8953Z",
    fill: "url(#paint21_linear_1_3)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4033 45.6738H52.6903L52.0656 44.1471H48.7913L48.1666 45.6738H46.494L49.6375 38.5496H51.2497L54.4033 45.6738ZM49.3152 42.8953H51.5518L50.4335 40.1679L49.3152 42.8953Z",
    fill: "url(#paint22_linear_1_3)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.339 38.5496C60.6462 38.5496 62.2279 39.9542 62.2279 42.1118C62.2279 44.2693 60.6462 45.6737 58.339 45.6738H55.135V38.5496H58.339ZM56.7671 44.3201H58.2584C59.6588 44.3201 60.5756 43.4755 60.5757 42.1118C60.5757 40.7481 59.6588 39.9032 58.2584 39.9032H56.7671V44.3201Z",
    fill: "url(#paint23_linear_1_3)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0912 45.6738H63.459V38.5496H65.0912V45.6738Z",
    fill: "url(#paint24_linear_1_3)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4345 12.9146L24.0726 11.3685L24.7971 12.8324L25.2243 11.5382L25.3172 11.5428C25.7566 11.5639 26.4227 11.6649 26.9954 11.9025C27.5611 12.1372 28.0813 12.5256 28.137 13.1449C28.1977 13.8193 28.3801 14.863 28.7288 15.8123C29.0806 16.7702 29.5875 17.5931 30.2736 17.8818C31.4557 18.3793 32.0895 18.7564 32.2659 18.89L32.3432 18.9486L32.3052 19.0383L31.5255 20.8758L31.4216 20.8465C30.7601 20.6585 29.7498 20.2956 28.8656 19.8155C28.4235 19.5755 28.0088 19.3039 27.6841 19.0073C27.5462 18.8813 27.4228 18.749 27.3201 18.611L27.6549 23.4574H26.9056L26.7859 27.9289L26.7854 27.9367L26.1782 34.6822L28.3201 35.8843L28.4091 35.9345L28.1031 36.8617H25.7619L25.2608 36.4821L23.9378 36.2392L23.837 36.2205V28.9136L23.9234 26.7275C23.3841 28.5827 22.6888 31.8281 22.8538 34.7447L22.8557 34.7777L22.6124 35.2691C22.6525 35.5412 22.6988 35.94 22.7127 36.3015C22.7199 36.4908 22.7185 36.6739 22.7019 36.8246C22.6936 36.8999 22.6811 36.9707 22.6625 37.0316C22.6446 37.0903 22.6175 37.152 22.5723 37.1977C22.5196 37.2509 22.4477 37.2816 22.3772 37.3005C22.3046 37.3198 22.2208 37.3298 22.1326 37.3329C21.956 37.3392 21.7467 37.3184 21.5406 37.2784C21.3343 37.2383 21.1259 37.1777 20.951 37.1017C20.7816 37.0281 20.6224 36.9311 20.5401 36.8064C20.4184 36.6221 20.4005 36.3698 20.4153 36.1519C20.4295 35.9428 20.4761 35.7408 20.5178 35.6072C20.4361 34.6371 20.3515 32.3977 20.3596 29.9916C20.3677 27.5984 20.4676 25.0283 20.7558 23.3753L20.2711 22.8856L20.274 22.8306C20.2946 22.4144 20.3439 21.7352 20.4251 21.0474C20.5061 20.3623 20.6197 19.6582 20.7714 19.1983C20.91 18.7783 20.9026 18.2733 20.8312 17.8042C20.7737 17.4262 20.6756 17.0803 20.5881 16.8351C20.3037 17.1207 19.8896 17.8809 20.0114 19.3098L20.0273 19.472L20.0275 19.4739L20.286 22.2163H18.2084L17.4503 18.643L17.4477 18.6301V18.617C17.4477 18.364 17.4665 17.9608 17.5228 17.5691C17.5509 17.3732 17.5886 17.1777 17.6392 17.0043C17.6892 16.8327 17.7542 16.6735 17.8408 16.5568C17.9022 16.474 17.9877 16.2859 18.0868 16.0169C18.1838 15.7535 18.2889 15.4273 18.393 15.081C18.6011 14.3885 18.8032 13.621 18.9257 13.126L18.9377 13.0772L18.98 13.0508L21.9289 11.1891L22.0215 11.1305L23.4345 12.9146ZM23.9599 18.617C23.7563 18.617 23.5912 18.7837 23.5912 18.9894C23.5912 19.195 23.7563 19.3617 23.9599 19.3617C24.1634 19.3617 24.3285 19.195 24.3285 18.9894C24.3285 18.7837 24.1634 18.617 23.9599 18.617ZM25.68 18.617C25.4765 18.617 25.3114 18.7837 25.3114 18.9894C25.3114 19.195 25.4765 19.3617 25.68 19.3617C25.8836 19.3617 26.0487 19.195 26.0487 18.9894C26.0487 18.7837 25.8836 18.617 25.68 18.617ZM23.9599 16.8794C23.7563 16.8794 23.5912 17.0461 23.5912 17.2518C23.5912 17.4574 23.7563 17.6241 23.9599 17.6241C24.1634 17.6241 24.3285 17.4574 24.3285 17.2518C24.3285 17.0461 24.1634 16.8794 23.9599 16.8794ZM25.68 16.8794C25.4765 16.8794 25.3114 17.0461 25.3114 17.2518C25.3114 17.4574 25.4765 17.6241 25.68 17.6241C25.8836 17.6241 26.0487 17.4574 26.0487 17.2518C26.0487 17.0461 25.8836 16.8794 25.68 16.8794ZM23.7141 15.1418C23.5105 15.1418 23.3455 15.3085 23.3455 15.5142C23.3455 15.7198 23.5105 15.8865 23.7141 15.8865C23.9177 15.8865 24.0827 15.7198 24.0827 15.5142C24.0827 15.3085 23.9177 15.1418 23.7141 15.1418ZM25.4343 15.1418C25.2307 15.1418 25.0657 15.3085 25.0657 15.5142C25.0657 15.7198 25.2307 15.8865 25.4343 15.8865C25.6379 15.8865 25.8029 15.7198 25.8029 15.5142C25.8029 15.3085 25.6379 15.1418 25.4343 15.1418Z",
    fill: "url(#paint25_linear_1_3)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6667 0C45.2908 0 53.5841 2.13302 58.9956 4.28919C61.7001 5.36677 63.6812 6.44857 64.9954 7.26937C65.6525 7.67971 66.1427 8.02465 66.4732 8.271C66.6384 8.39415 66.7637 8.49267 66.85 8.56238C66.8931 8.59723 66.9266 8.62486 66.9503 8.64479C66.9622 8.65476 66.9716 8.66299 66.9786 8.66904C66.9821 8.67204 66.9852 8.67454 66.9875 8.67655C66.9886 8.67753 66.9895 8.67848 66.9904 8.67922C66.9908 8.67957 66.9916 8.68019 66.9916 8.68019C66.9921 8.68062 66.9926 8.68099 66.3504 9.43262L66.9926 8.68091L67.3333 8.97811V34.4257C67.3333 35.0324 67.3154 35.6379 67.2805 36.2411H65.3112C65.3484 35.6386 65.3674 35.0331 65.3674 34.4257V9.9155C65.3477 9.90065 65.3274 9.88492 65.306 9.86896C65.0173 9.65377 64.5714 9.33934 63.9616 8.95847C62.742 8.19682 60.8652 7.16869 58.2742 6.13634C53.0949 4.07267 45.0464 1.98582 33.6667 1.98582C22.2869 1.98582 14.2385 4.07267 9.0591 6.13634C6.46814 7.16869 4.59132 8.19682 3.37175 8.95847C2.76191 9.33934 2.31608 9.65377 2.02737 9.86896C2.00596 9.88492 1.98563 9.90065 1.96594 9.9155V34.1363C1.96594 34.8411 1.99145 35.5432 2.04153 36.2411H0.0710348C0.0240672 35.5423 1.87406e-06 34.8402 0 34.1363V8.97811L0.340775 8.68091L0.982968 9.43262C0.340682 8.68099 0.341233 8.68062 0.341735 8.68019C0.341735 8.68019 0.342522 8.67957 0.342935 8.67922C0.343781 8.67848 0.344685 8.67753 0.345815 8.67655C0.348137 8.67454 0.351186 8.67204 0.354694 8.66904C0.361753 8.66299 0.371144 8.65476 0.383012 8.64479C0.406748 8.62486 0.440188 8.59723 0.483325 8.56238C0.569603 8.49267 0.694883 8.39415 0.860097 8.271C1.1906 8.02465 1.68087 7.67971 2.33791 7.26937C3.65217 6.44857 5.63323 5.36677 8.33771 4.28919C13.7492 2.13302 22.0425 0 33.6667 0Z",
    fill: "url(#paint26_linear_1_3)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6399 29.0426C50.3185 29.0426 50.8686 29.5982 50.8686 30.2837C50.8686 30.9691 50.3185 31.5248 49.6399 31.5248C48.9613 31.5248 48.4112 30.9691 48.4112 30.2837C48.4112 29.5982 48.9613 29.0426 49.6399 29.0426Z",
    fill: "url(#paint27_linear_1_3)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6399 25.5674C52.2186 25.5674 54.309 27.6789 54.309 30.2837C54.309 32.8884 52.2186 35 49.6399 35C47.0612 35 44.9708 32.8884 44.9708 30.2837C44.9708 27.6789 47.0612 25.5674 49.6399 25.5674ZM49.6399 27.305C48.0113 27.305 46.691 28.6386 46.691 30.2837C46.691 31.9288 48.0113 33.2624 49.6399 33.2624C51.2685 33.2624 52.5888 31.9288 52.5888 30.2837C52.5888 28.6386 51.2685 27.305 49.6399 27.305Z",
    fill: "url(#paint28_linear_1_3)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4742 15.391C31.9175 15.0888 34.657 15.9492 37.0778 17.134C39.4734 18.3064 41.5374 19.6879 42.7591 20.727C45.3394 20.9752 47.1337 20.727 49.9281 21.141C52.4892 21.5205 54.9397 22.0721 56.4192 22.466C60.5495 22.8666 61.6629 25.0371 61.6803 26.1613C62.2742 27.5829 61.9257 28.8696 61.6661 29.3502L61.6621 29.3582L61.6568 29.3652C61.6051 29.4348 61.5417 29.5581 61.5236 29.6922C61.5061 29.8218 61.5306 29.956 61.6453 30.0718C61.8287 30.2571 61.861 30.4974 61.837 30.7045C61.8135 30.9068 61.7349 31.094 61.6673 31.2097C61.5282 31.5146 61.2795 31.7303 60.9277 31.8843C60.5768 32.0379 60.1167 32.1332 59.5445 32.1973C58.4012 32.3252 56.7638 32.3317 54.5581 32.3936L54.3781 32.3987L54.4391 32.2276C54.8015 31.2106 55.278 28.6803 53.3599 26.6459C51.4415 24.6112 48.8064 24.5816 46.6363 26.043C44.4845 27.492 44.1166 30.1553 44.841 32.2283L44.8988 32.3936H41.3516L41.4157 32.2251C43.6656 26.2964 42.2575 22.6337 40.833 21.3148C40.1063 20.6419 39.2253 20.0891 38.5229 19.7035C38.1723 19.511 37.8674 19.3608 37.6504 19.2589C37.5419 19.208 37.4554 19.1691 37.3962 19.143C37.3667 19.1301 37.3441 19.1202 37.3288 19.1137C37.3212 19.1105 37.3153 19.1081 37.3115 19.1064C37.3096 19.1056 37.3081 19.1051 37.3072 19.1047L37.3062 19.1043L37.306 19.104L37.2892 19.0972L37.2753 19.0856C34.6515 16.9261 30.9892 16.383 29.489 16.383H29.3662V15.4044L29.4742 15.391ZM56.1521 23.9539C56.2749 24.9468 57.4053 26.9574 60.944 27.0567C60.6573 26.3121 59.9365 24.7731 59.3467 24.5745C58.3637 24.2435 56.9712 24.078 56.1521 23.9539ZM45.9538 21.9681C46.347 22.266 51.483 22.961 55.292 23.4574C53.8175 22.8369 48.616 22.1749 45.9538 21.9681Z",
    fill: "url(#paint29_linear_1_3)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7653 21.6413C41.3392 22.3498 41.8972 23.7731 42.0675 25.6336C42.2382 27.4986 42.0205 29.8144 41.03 32.3156L40.9993 32.3936H30.4245L30.4783 32.2302C31.0044 30.6357 31.7465 26.2926 30.4766 21.7536L30.4324 21.5957H40.7286L40.7653 21.6413ZM32.438 24.5745H34.6496V24.078H32.438V24.5745Z",
    fill: "url(#paint30_linear_1_3)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6594 30.5319L10.5669 30.0355L19.6594 29.539V30.5319Z",
    fill: "url(#paint31_linear_1_3)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6594 28.2979L7.86375 27.8014L19.6594 27.305V28.2979Z",
    fill: "url(#paint32_linear_1_3)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6594 26.0638L6.14355 25.5674L19.6594 25.0709V26.0638Z",
    fill: "url(#paint33_linear_1_3)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1849 23.5816L6.38929 23.0851L18.1849 22.5887V23.5816Z",
    fill: "url(#paint34_linear_1_3)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1752 19.1649C34.453 18.867 35.0182 19.8063 34.4039 21.0474C34.4039 21.4198 32.9295 21.7464 33.4209 21.1507C33.9124 20.555 33.4619 19.5786 33.1752 19.1649Z",
    fill: "url(#paint35_linear_1_3)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2019 21.3475L5.40633 20.8511L17.2019 20.3546V21.3475Z",
    fill: "url(#paint36_linear_1_3)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9562 18.8652L6.63504 18.3688L16.9562 17.8723V18.8652Z",
    fill: "url(#paint37_linear_1_3)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6253 7.07447C23.5912 5.58511 25.4753 5.70922 26.1715 5.95745V6.82624L25.9258 7.07447V8.06738C26.4173 8.26596 26.4582 8.56383 26.4173 8.68794C24.9428 9.1844 23.1817 8.48109 22.4854 8.06738H21.9939C21.6007 7.57092 21.5843 7.19858 21.6253 7.07447Z",
    fill: "url(#paint38_linear_1_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1_3",
    x1: -5.5877e-9,
    y1: 28.2979,
    x2: 67.3336,
    y2: 29.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491584,
    stopColor: "#FFEB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA3D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1f0da8bf11f0fc285a010bc8c5bf94a0.svg";
export { ForwardRef as ReactComponent };